import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import LanguageIcon from '@mui/icons-material/Language';
import discordIcon from '../../../img/discord-mark-white.png';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';

import { useStyles } from './ResponsiveDrawer.styles';
import { getDrawerItems } from './drawerItems';

import { appActions } from '../../../actions/app.actions';
import { getFormattedLanguage } from '../../../utils/page.utils';
import logo from '../../../img/textLogo.png';
import betaImg from '../../../img/beta.png';
import { Link } from 'react-router-dom';

const ResponsiveDrawer = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t } = useTranslation();
  const user = useSelector(state => state.user);
  const { pathname } = useLocation();
  const [fontStyle, setFontStyle] = useState('TheJamsil');
  const [open, setOpen] = useState({
    music: false,
    speech: false,
    image: false,
    video: false,
    history: false,
  });

  const drawerItems = getDrawerItems(t);
  const formattedLanguage = getFormattedLanguage();
  const openLanguageModal = () => dispatch(appActions.openLanguageModal());

  const handleOpen = section => {
    setOpen(prevState => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  useEffect(() => {
    const defaultLanguage = localStorage.getItem('selectedLanguage') || navigator.language.split('-')[0];
    const defaultFont = defaultLanguage === 'ja' ? 'MPlus1' : 'TheJamsil';
    setFontStyle(defaultFont);
  }, []);

  const drawer = (
    <div className={`${classes.drawer} ${fontStyle}`} style={{ color: 'red!important' }}>
      <div className={classes.container}>
        <Link to={'/'}>
          <img className={classes.logo} src={logo} alt="Logo" />
        </Link>
        <List disablePadding>
          <div className={classes.subHeader}>{t('appBar.create')}</div>
          {drawerItems.music.title.map(({ text, icon }, index) => (
            <ListItem key={index} className={classes.drawerListItem} onClick={() => handleOpen('music')}>
              <div className={classes.drawerListTitle}>
                <img className={classes.drawerListImg} src={icon} alt="list Icon" />
                <div className={classes.drawerListText}>{text}</div>
              </div>
              {open.music ? (
                <ExpandLess className={classes.expandIcon} />
              ) : (
                <ExpandMore className={classes.expandIcon} />
              )}
            </ListItem>
          ))}
          <Collapse in={open.music} timeout="auto" unmountOnExit>
            <List component="div" className={classes.subDrawerList}>
              {drawerItems.music.links.map(({ text, to }, index) => (
                <ListItem
                  selected={pathname === `/${to}`}
                  component={!!to ? RouterLink : null}
                  to={`/${to}`}
                  button={!!to}
                  key={index}
                  className={classes.subDrawerListItem}
                  onClick={() => props.open && props.handleDrawerToggle()}
                >
                  <div className={classes.subDrawerListText}>{text}</div>
                </ListItem>
              ))}
            </List>
          </Collapse>
          {drawerItems.speech.title.map(({ text, icon }, index) => (
            <ListItem key={index} className={classes.drawerListItem} onClick={() => handleOpen('speech')}>
              <div className={classes.drawerListTitle}>
                <img className={classes.drawerListImg} src={icon} alt="list Icon" />
                <div className={classes.drawerListText}>{text}</div>
              </div>
              {open.speech ? (
                <ExpandLess className={classes.expandIcon} />
              ) : (
                <ExpandMore className={classes.expandIcon} />
              )}
            </ListItem>
          ))}
          <Collapse in={open.speech} timeout="auto" unmountOnExit>
            <List component="div" className={classes.subDrawerList}>
              {drawerItems.speech.links.map(({ text, to }, index) => (
                <ListItem
                  sx={{ pl: 4 }}
                  selected={pathname === `/${to}`}
                  component={!!to ? RouterLink : null}
                  to={`/${to}`}
                  button={!!to}
                  key={index}
                  className={classes.subDrawerListItem}
                  onClick={() => props.open && props.handleDrawerToggle()}
                >
                  <div className={classes.subDrawerListText}>{text}</div>
                </ListItem>
              ))}
            </List>
          </Collapse>
          {drawerItems.image.title.map(({ text, icon }, index) => (
            <ListItem key={index} className={classes.drawerListItem} onClick={() => handleOpen('image')}>
              <div className={classes.drawerListTitle}>
                <img className={classes.drawerListImg} src={icon} alt="list Icon" />
                <div className={classes.drawerListText}>{text}</div>
              </div>
              {open.image ? (
                <ExpandLess className={classes.expandIcon} />
              ) : (
                <ExpandMore className={classes.expandIcon} />
              )}
            </ListItem>
          ))}
          <Collapse in={open.image} timeout="auto" unmountOnExit>
            <List component="div" className={classes.subDrawerList}>
              {drawerItems.image.links.map(({ text, to }, index) => (
                <ListItem
                  sx={{ pl: 4 }}
                  selected={pathname === `/${to}`}
                  component={!!to ? RouterLink : null}
                  to={`/${to}`}
                  button={!!to}
                  key={index}
                  className={classes.subDrawerListItem}
                  onClick={() => props.open && props.handleDrawerToggle()}
                >
                  <div className={classes.subDrawerListText}>{text}</div>
                </ListItem>
              ))}
            </List>
          </Collapse>
          {drawerItems.video.title.map(({ text, icon }, index) => (
            <ListItem key={index} className={classes.drawerListItem} onClick={() => handleOpen('video')}>
              <div className={classes.drawerListTitle}>
                <img className={classes.drawerListImg} src={icon} alt="list Icon" />
                <div className={classes.drawerListText}>{text}</div>
              </div>
              {open.video ? (
                <ExpandLess className={classes.expandIcon} />
              ) : (
                <ExpandMore className={classes.expandIcon} />
              )}
            </ListItem>
          ))}
          <Collapse in={open.video} timeout="auto" unmountOnExit>
            <List component="div" className={classes.subDrawerList}>
              {drawerItems.video.links.map(({ text, to }, index) => (
                <ListItem
                  sx={{ pl: 4 }}
                  selected={pathname === `/${to}`}
                  component={!!to ? RouterLink : null}
                  to={`/${to}`}
                  button={!!to}
                  key={index}
                  className={classes.subDrawerListItem}
                  onClick={() => props.open && props.handleDrawerToggle()}
                >
                  <div className={classes.subDrawerListText}>{text}</div>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </List>

        {drawerItems.videoEditor.links.map(({ text, icon, to }, index) => (
          <ListItem
            selected={pathname === `/${to}`}
            component={!!to ? RouterLink : null}
            to={`/${to}`}
            button={!!to}
            key={index}
            className={classes.drawerListItem}
            onClick={() => props.open && props.handleDrawerToggle()}
          >
            <div className={classes.drawerListTitle}>
              <img className={classes.drawerListImg} src={icon} alt="list Icon" />
              <div className={classes.drawerListText}>{text}</div>
            </div>
          </ListItem>
        ))}

        {drawerItems.community.links.map(({ text, icon, to }, index) => (
          <ListItem
            selected={pathname === `/${to}`}
            component={!!to ? RouterLink : null}
            to={`/${to}`}
            button={!!to}
            key={index}
            className={classes.drawerListItem}
            onClick={() => props.open && props.handleDrawerToggle()}
          >
            <div className={classes.drawerListTitle}>
              <img className={classes.drawerListImg} src={icon} alt="list Icon" />
              <div className={classes.drawerListText}>{text}</div>
            </div>
          </ListItem>
        ))}

        <List disablePadding>
          <div className={classes.subHeader}>{t('appBar.account')}</div>
          {drawerItems.history.title.map(({ text }, index) => (
            <ListItem key={index} className={classes.drawerListItem} onClick={() => handleOpen('history')}>
              <div className={classes.drawerListText}>{text}</div>
              {open.history ? (
                <ExpandLess  className={classes.expandIcon} />
              ) : (
                  <ExpandMore className={classes.expandIcon} />
              )}
            </ListItem>
          ))}
          <Collapse in={open.history} timeout="auto" unmountOnExit>
            <List component="div" className={classes.subDrawerList}>
              {drawerItems.history.links.map(({ text, to }, index) => (
                <ListItem
                  sx={{ pl: 4 }}
                  selected={pathname === `/${to}`}
                  component={!!to ? RouterLink : null}
                  to={`/${to}`}
                  button={!!to}
                  key={index}
                  className={classes.subDrawerListItem}
                  onClick={() => props.open && props.handleDrawerToggle()}
                >
                  <div className={classes.subDrawerListText}>{text}</div>
                </ListItem>
              ))}
            </List>
          </Collapse>
          {drawerItems.account.links.map(({ text, to }, index) => (
            <ListItem
              selected={pathname === `/${to}`}
              component={!!to ? RouterLink : null}
              to={`/${to}`}
              button={!!to}
              key={index}
              className={classes.drawerListItem}
              onClick={() => props.open && props.handleDrawerToggle()}
            >
              <div className={classes.drawerListText}>{text}</div>
            </ListItem>
          ))}
        </List>

        <div className={classes.separater} />
        <List disablePadding>
          {/* <ListItem
            button={true}
            key={drawerItems.help.length}
            onClick={() => window.open(t('supportTab.link'), '_blank')}
            className={classes.drawerListItem}
          >
            <div className={classes.drawerListTitle}>
              <img className={classes.discordImg} src={discordIcon} alt="discord Icon" />
              <div className={classes.drawerListText}>{t('supportTab.title')}</div>
            </div>
          </ListItem> */}
          {drawerItems.help.links.map(({ text, icon, to }, index) => (
            <ListItem
              selected={pathname === `/${to}`}
              component={!!to ? RouterLink : null}
              to={`/${to}`}
              button={!!to}
              key={index}
              className={classes.drawerListItem}
              onClick={() => props.open && props.handleDrawerToggle()}
            >
              <div className={classes.drawerListTitle}>
                <img className={classes.drawerListImg} src={icon} alt="list Icon" />
                <div className={classes.drawerListText}>{text}</div>
              </div>
            </ListItem>
          ))}
        </List>
      </div>
      <div>
        <div className={classes.languageContainer} onClick={openLanguageModal}>
          <LanguageIcon />
          <div className={classes.selectedLanguage}>{formattedLanguage}</div>
          <ExpandMore />
        </div>
      </div>
    </div>
  );

  return (
    <nav>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          open={props.open}
          onClose={props.handleDrawerToggle}
          classes={{ paper: classes.drawerPaper }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer classes={{ paper: classes.drawerPaper }} variant="permanent">
          {drawer}
        </Drawer>
      </Hidden>
    </nav>
  );
};

export default ResponsiveDrawer;
